export const ModalityAudience = [
    { value: 'presencial', label: 'Presencial' },
    { value: 'online', label: 'Virtual' },    
];